import React from 'react';
import { Card, Tabs } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const { TabPane } = Tabs;

function Download() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname.split('/')[2];
  const currentTab = currentPath || 'campaign-download';

  const tabKeyMap = {
    'campaign-download': '1',
    'offender-download': '2',

  };

  const keyTabMap = {
    '1': 'campaign-download',
    '2': 'offender-download',

  };


  React.useEffect(() => {
    if (location.pathname === '/downloads') {
      navigate('/downloads/campaign-download', { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (key) => {
    navigate(`/downloads/${keyTabMap[key]}`);
  };

  const activeKey = tabKeyMap[currentTab];

  return (
    <div className="lms-body">
      <h2 style={{ marginBottom: "20px" }}>
        Download Reports
      </h2>
      <Card>
        <Tabs activeKey={activeKey} onChange={handleTabChange}>
          <TabPane tab="Campaign download" key="1" />
          <TabPane tab="Offender download" key="2" />

        </Tabs>

        <Outlet />
      </Card>
    </div>
  );
}

export default Download;
